module.exports = __webpack_public_path__ + "img/home.211aad7f.svg";